import React from 'react'
import { Modal, Button } from '@guillotinaweb/react-gmi'

export default function Confirm({ open, yes, no, children }) {
  return (
    <Modal isActive={open} setActive={no}>
      {children}
      <div className="level level-right">
        <Button style={{ marginRight: 10 }} onClick={no}>
          No
        </Button>
        <Button className="is-default" onClick={yes}>
          Yes
        </Button>
      </div>
    </Modal>
  )
}
